import { useState } from 'react';

import Button from 'components/shared/Button';
import Modal from 'components/shared/Modal';
import ReactPortal, { useReactPortal } from 'components/shared/ReactPortal';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import s from './index.module.css';

const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return {
    isOpen,
    toClose: () => setIsOpen(false),
    toOpen: () => setIsOpen(true),
  };
};

function MobileModalWrapper({ children, className }) {
  const mobileAttentionModal = useModal();
  const internalPortal = useReactPortal({ wrapperId: 'internal-modal' });
  const { isMobile } = useMediaBreakpoints();

  if (!isMobile) return children;

  return (
    <>
      <ReactPortal {...internalPortal}>
        <Modal {...mobileAttentionModal} withoutCloseBtn>
          <div className={s.modalContent}>
            <div className={s.titleWrapper}>
              <FormTitle center>Heads Up!</FormTitle>
            </div>
            <div className={s.textDescriptionWrapper}>
              <Text accent size="large">
                You are only able to customize the tail (“slug”) of links from your desktop.
              </Text>
            </div>
            <Button size="large" onClick={mobileAttentionModal.toClose}>
              Got it
            </Button>
          </div>
        </Modal>
      </ReactPortal>

      <div className={className} onClick={mobileAttentionModal.toOpen}>
        {children}
      </div>
    </>
  );
}

export default MobileModalWrapper;
